import APINoSubdomain from "../APINoSubdomain";

export const signupAPI = (payload) => {
  return APINoSubdomain.post("/auth/signup", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const loginAPI = (payload) => {
  return APINoSubdomain.post("/auth/login", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const forgetPasswordAPI = (payload) => {
  return APINoSubdomain.put(`/auth/forgotpassword?&email=${payload.email}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const ChangePasswordAPI = (payload) => {
  return APINoSubdomain.put(`/changepassword?token=${payload.token}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};
